/**
 * Toggle the activity notifications pane
 *
 * @param  {Object} state
 * @return {Void}
 */
const TOGGLE_ACTIVITY = (state) => {
    state.showActivity = !state.showActivity
}

/**
 * Reset the indicator state
 *
 * @param  {Object} state
 * @return {Void}
 */
const DISABLE_INDICATOR = (state) => {
    state.showIndicator = false
}

/**
 * Reset the activity state
 *
 * @param  {Object} state
 * @return {Void}
 */
const CLOSE_ACTIVITY = (state) => {
    state.showActivity = false
}

const GET_ACTIVITY = (state) => {
    state.error = false
    state.pending = true
}

const GET_ACTIVITY_SUCCESS = (state, data) => {
    state.data = data
    state.pending = false
}

const GET_ACTIVITY_FAILURE = (state, err) => {
    state.error = true
    state.pending = false
}

const MARK_ITEM_READ = (state, id) => {
    let item = state.data.find(i => i.id === id)
    if (item) {
        item.read = true
    }
}

const MARK_ALL_READ = (state) => {
    state.data = state.data.map(item => {
        item.read = true
        return item
    })
}

const PREPEND_ACTIVITY = (state, activity) => state.data.unshift(activity)

const SEND_ACTIVITY_POPUP = (state, activity) => {
    state.popup.data = activity
    state.popup.show = true
}

const RESET_ACTIVITY_POPUP = (state) => {
    state.popup.show = false
    state.activity = {}
}

export default {
    GET_ACTIVITY,
    GET_ACTIVITY_SUCCESS,
    GET_ACTIVITY_FAILURE,
    CLOSE_ACTIVITY,
    TOGGLE_ACTIVITY,
    DISABLE_INDICATOR,
    MARK_ITEM_READ,
    MARK_ALL_READ,
    PREPEND_ACTIVITY,
    RESET_ACTIVITY_POPUP,
    SEND_ACTIVITY_POPUP
}



// WEBPACK FOOTER //
// ./src/state/modules/activity/mutations.js